// Store Imports
import { createReducer, on } from '@ngrx/store'
import { SIGNIN, SIGNOUT } from '@store/actions'
import { IAuthState } from '@store/models'
// Shared Imports
import { ELocalStorageKeys, ERoles } from '@shared/models'

export const initialAuthState: IAuthState = {
	logged: false,
	accessToken: '',
	refreshToken: '',
	// roles: [ERoles.viewer, ERoles.administrator],
	roles: [ERoles.viewer],
}

export const authReducer = createReducer(
	initialAuthState,
	// ----------SIGNIN----------
	on(SIGNIN, (previousState: IAuthState, { accessToken, refreshToken }): IAuthState => {
		// We save the tokens in the local storage
		window.localStorage.setItem(ELocalStorageKeys.accessToken, accessToken)
		window.localStorage.setItem(ELocalStorageKeys.refreshToken, refreshToken)

		return {
			...previousState,
			logged: true,
			accessToken,
			refreshToken,
		}
	}),
	// ----------SIGNOUT----------
	on(SIGNOUT, (previousState: IAuthState): IAuthState => {
		// We remove the tokens from the local storage
		window.localStorage.removeItem(ELocalStorageKeys.accessToken)
		window.localStorage.removeItem(ELocalStorageKeys.refreshToken)
		return { ...previousState, ...initialAuthState }
	})
)
